function ThumbsDownIconFilled({ color = 'currentColor', height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M4.99967 2.5H13.333V13.3333L7.49967 19.1667L6.45801 18.125C6.36079 18.0278 6.28093 17.8958 6.21843 17.7292C6.15593 17.5625 6.12467 17.4028 6.12467 17.25V16.9583L7.04134 13.3333H2.49967C2.05523 13.3333 1.66634 13.1667 1.33301 12.8333C0.999674 12.5 0.833008 12.1111 0.833008 11.6667V10C0.833008 9.90278 0.84343 9.79861 0.86426 9.6875C0.88509 9.57639 0.91634 9.47222 0.958008 9.375L3.45801 3.5C3.58301 3.22222 3.79134 2.98611 4.08301 2.79167C4.37467 2.59722 4.68023 2.5 4.99967 2.5ZM15.0003 2.5V13.3333H18.333V2.5H15.0003Z"
        fill={color}
      />
    </svg>
  );
}
export default ThumbsDownIconFilled;
